export default "__VITE_ASSET__CxnkN9oU__"